import { BaseContainerModel } from "../../base-container.model";
import { bl_alg_cc_skill_hdr_RowClass } from "../../../dbschema";

export class SkillHdrContainerModel extends BaseContainerModel{
  bl_alg_cc_skill_hdr: bl_alg_cc_skill_hdr_RowClass = new bl_alg_cc_skill_hdr_RowClass();
}
